import { useState } from "react";
import { Lock } from "lucide-react";
import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";
import { submitForm } from "../../../api/submitForm";
import Honeypot from "../../../components/honeypot";
import { useFormTiming } from "../../../components/useFormTiming";

const Login = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.login");
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const startedAt = useFormTiming();
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    const result = await submitForm("notify", "deviceworks", { email }, { hp, startedAt });
    if (result.ok) {
      setStatus("sent");
    } else {
      setStatus("error");
      setError(result.error);
    }
  };

  return (
    <div>
      <PageHeader eyebrow={<span className="dw-badge">{h.eyebrow}</span>} title={h.title} description={h.description} />

      <div className="max-w-sm mx-auto px-5 py-16 text-center">
        <Lock className="mx-auto" size={32} strokeWidth={1.5} style={{ color: "var(--dw-text-faint)" }} />

        <button
          type="button"
          disabled
          className="dw-btn w-full justify-center mt-6 opacity-50 cursor-not-allowed"
          aria-disabled="true"
          title="Not yet available"
        >
          Sign in with iTrust.ID
        </button>
        <p className="dw-mini text-xs pt-2">Not yet available — this will use iTrust.ID single sign-on once live.</p>

        <div className="pt-10 border-t mt-10" style={{ borderColor: "var(--dw-line)" }}>
          <h3 className="pb-3">Notify Me at Launch</h3>
          {status === "sent" ? (
            <p className="dw-mini">Thanks — we'll let you know.</p>
          ) : (
            <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
              <Honeypot value={hp} onChange={(e) => setHp(e.target.value)} />
              <input
                type="email"
                className="dw-field"
                placeholder="Email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit" className="dw-btn-outline w-full justify-center" disabled={status === "sending"}>
                {status === "sending" ? "Submitting…" : "Notify Me"}
              </button>
              {status === "error" && <p className="dw-mini" style={{ color: "#e06666" }}>{error}</p>}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
